export const enviroment = {
    niquelVersion: '2.77.0',
    apiVersion: 'v1',
    servers: [
        {name: process.env.REACT_APP_API_NAME_SERVER_1, url: process.env.REACT_APP_API_URL_SERVER_1},
        {name: process.env.REACT_APP_API_NAME_SERVER_2, url: process.env.REACT_APP_API_URL_SERVER_2},
        {name: process.env.REACT_APP_API_NAME_SERVER_3, url: process.env.REACT_APP_API_URL_SERVER_3},
    ]
};
